"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _reactRouter = require("react-router");

var _components = require("../../components");

var _subscriptions = require("../../redux/modules/subscriptions");

var _utils = require("../../utils");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _CheckoutLayout = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/CheckoutLayout");

var _CheckoutLayout2 = _interopRequireDefault(_CheckoutLayout);

var _ChoicePriceBox = require("@quixeltools/quixel-ui-library/dist/components/megascans/subscriptions/ChoicePriceBox");

var _ChoicePriceBox2 = _interopRequireDefault(_ChoicePriceBox);

var _ChoicePriceStickyHeader = require("@quixeltools/quixel-ui-library/dist/components/megascans/subscriptions/ChoicePriceStickyHeader");

var _ChoicePriceStickyHeader2 = _interopRequireDefault(_ChoicePriceStickyHeader);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _SiteHeaderGap = require("@quixeltools/quixel-ui-library/dist/components/common/website/SiteHeaderGap");

var _SiteHeaderGap2 = _interopRequireDefault(_SiteHeaderGap);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spinnerStyles = (0, _glamor.css)({
  width: "100%",
  height: "400px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& span": {
    width: "40px",
    height: "40px",
    border: "2px solid transparent",
    borderLeftColor: "gray"
  }
});

var checkoutButton = (0, _glamor.css)({
  display: "none"
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  display: "block",
  float: "right"
}), (0, _polyfluid.polyfluid)({
  paddingTop: {
    smallMedium: 2.25,
    large: [2.25, 3]
  },
  paddingBottom: {
    smallMedium: 2.25,
    large: [2.25, 3]
  }
}));

var collapseResolution = function collapseResolution(plans) {
  return {
    field: "accessResolution",
    options: _ramda2.default.compose(_ramda2.default.map(function (value) {
      return {
        name: (0, _utils.getResolutionShortform)(value + "x" + value),
        value: value
      };
    }), _ramda2.default.uniq, _ramda2.default.map(_ramda2.default.prop("accessResolution")))(plans)
  };
};

var collapseHigherRevenueAlternative = function collapseHigherRevenueAlternative(plans) {
  return {
    field: "higherRevenueAlternate",
    options: _ramda2.default.compose(_ramda2.default.map(function (value) {
      return {
        name: value ? "$100K+" : "<$100K",
        value: value
      };
    }), _ramda2.default.uniq, _ramda2.default.map(_ramda2.default.prop("higherRevenueAlternate")))(plans)
  };
};

var collapseBillingPlan = function collapseBillingPlan(plans) {
  return {
    field: "billing",
    options: _ramda2.default.compose(_ramda2.default.map(function (value) {
      return {
        name: value === "monthly" ? "Monthly" : "Yearly",
        value: value
      };
    }), _ramda2.default.uniq, _ramda2.default.map(_ramda2.default.prop("billing")))(plans)
  };
};

var collapsePointsPlan = function collapsePointsPlan(plans) {
  return {
    field: "points",
    options: _ramda2.default.compose(_ramda2.default.map(function (value) {
      return {
        name: value,
        value: value
      };
    }), _ramda2.default.uniq, _ramda2.default.map(_ramda2.default.prop("points")))(plans)
  };
};
var collapseMonthPlan = function collapseMonthPlan(plans) {
  return {
    field: "billingCycle",
    options: _ramda2.default.compose(_ramda2.default.map(function (value) {
      return {
        name: value,
        value: value
      };
    }), _ramda2.default.uniq, _ramda2.default.map(_ramda2.default.prop("billingCycle")))(plans)
  };
};

var convergeFields = _ramda2.default.applySpec({
  fields: _ramda2.default.map(_ramda2.default.prop("field")),
  options: _ramda2.default.compose(_ramda2.default.fromPairs, _ramda2.default.map(_ramda2.default.values))
});

var multiValueFields = function multiValueFields(_ref) {
  var options = _ref.options;
  return _ramda2.default.compose(function (filtered) {
    return {
      fields: _ramda2.default.keys(filtered),
      options: filtered
    };
  }, _ramda2.default.reject(_ramda2.default.compose(_ramda2.default.gte(1), _ramda2.default.length)))(options);
};

var filterPlans = function filterPlans(license) {
  return _ramda2.default.filter(_ramda2.default.propEq("license", license));
};
var filterBPlans = function filterBPlans(license) {
  return _ramda2.default.filter(_ramda2.default.propEq("name", license));
};

var collapsePlans = function collapsePlans(license, plans) {
  return _ramda2.default.compose(multiValueFields, _ramda2.default.converge(_ramda2.default.unapply(convergeFields), [collapseResolution, collapseHigherRevenueAlternative, collapseBillingPlan]), filterPlans(license))(plans);
};

var collapseBusinessPlans = function collapseBusinessPlans(license, plans) {
  return _ramda2.default.compose(multiValueFields, _ramda2.default.converge(_ramda2.default.unapply(convergeFields), [collapseResolution, collapsePointsPlan]), filterBPlans(license))(plans);
};

var collapseEducationalPlans = function collapseEducationalPlans(license, plans) {
  return _ramda2.default.compose(multiValueFields, _ramda2.default.converge(_ramda2.default.unapply(convergeFields), [collapseMonthPlan]), filterPlans(license))(plans);
};

var collapseArchVizPlans = function collapseArchVizPlans(license, plans) {
  return _ramda2.default.compose(multiValueFields, _ramda2.default.converge(_ramda2.default.unapply(convergeFields), [collapseMonthPlan]), filterPlans(license))(plans);
};

var collapsePointsOfPlans = function collapsePointsOfPlans(license, plans) {
  return _ramda2.default.compose(multiValueFields, _ramda2.default.converge(_ramda2.default.unapply(convergeFields), [collapsePointsPlan]), filterPlans(license))(plans);
};

var ChooseSubscription = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState,
        name = _ref2.params.name;

    if (!(0, _subscriptions.hasSubscriptionPlans)(getState())) {
      return dispatch((0, _subscriptions.getSubscriptionPlans)()).then(function (plans) {
        var license = _ramda2.default.find(_ramda2.default.propEq("planType", name === "studio" ? "" : name), plans).license;

        if (!plans.find(function (plan) {
          return plan.license === license;
        })) {
          throw new Error("Plan license to choose for not found");
        }
      });
    }

    return _bluebird2.default.try(function () {
      var plans = getState().subscriptions.plans;
      var license = _ramda2.default.find(_ramda2.default.propEq("planType", name), plans).license;

      if (!plans.find(function (plan) {
        return plan.license === license;
      })) {
        throw new Error("Plan license to choose for not found");
      }
    });
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    isEolConfigLoading: state.eol.hasMonetizationStopped === null,
    hasMonetizationStopped: state.eol.hasMonetizationStopped,
    plans: state.subscriptions.subPlans,
    plansDecorated: state.subscriptions.plansDecorated,
    educationalPlan: state.subscriptions.educationalPlan,
    chosenPlan: state.subscriptions.chosenPlan,
    // projectName: state.subscriptions.projectNameForSubscription,
    // projectDetails: state.subscriptions.projectDetailsForSubscription,
    // seats: state.subscriptions.seatsForSubscription,
    paymentPlan: state.payments.currentPayment.paymentItem,
    shouldUpdateEula: state.auth.eula.updateVersion
  };
}, {
  setChosenPlan: _subscriptions.setChosenPlan,
  setProjectDetails: _subscriptions.setProjectDetails
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ChooseSubscription, _React$Component);

  function ChooseSubscription(props) {
    (0, _classCallCheck3.default)(this, ChooseSubscription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChooseSubscription.__proto__ || (0, _getPrototypeOf2.default)(ChooseSubscription)).call(this, props));

    _this.handleChoicesOptionChange = _this.handleChoicesOptionChange.bind(_this);
    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
    _this.onClickHandler = _this.onClickHandler.bind(_this);

    var plans = props.plans,
        name = props.params.name;

    var license = _ramda2.default.find(_ramda2.default.propEq("planType", name), plans).license;

    var selectedPlan = props.paymentPlan;
    if (!selectedPlan) {
      selectedPlan = _ramda2.default.compose(_ramda2.default.nth(0), _ramda2.default.sortBy(_ramda2.default.prop("amount")), filterPlans(license))(plans);
    }
    // let selectedPlan = paymentPlan;

    var seats = 1;
    var projectName = undefined;
    var projectDetails = undefined;
    if (props.chosenPlan && props.location.state && props.location.state.comingBackFromNextPage) {
      selectedPlan = props.chosenPlan;
      // seats = props.seats || 1;
      // projectName = props.projectName || undefined;
      // projectDetails = props.projectDetails || undefined;
    }

    props.setChosenPlan(selectedPlan);
    _this.state = {
      agreement: false,
      selectedPlan: selectedPlan,
      initialPlan: selectedPlan
      // ...selectedPlan.multiSeat && {
      //   seats: seats,
      //   projectName: projectName,
      //   projectDetails: projectDetails,
      // },
    };
    return _this;
  }

  (0, _createClass3.default)(ChooseSubscription, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var elem = document.getElementById("your-price");
      var flag = true;

      if (elem) {
        var scrollTo = elem.parentNode.clientHeight - elem.clientHeight + 77;
        elem.style.width = "22.3%";
        elem.style.maxWidth = "320px";
        if (window.scrollY + 60 > scrollTo) {
          elem.style.position = "absolute";
          if (flag === true) {
            elem.style.top = scrollTo + "px";
            flag = false;
          }
        } else if (window.scrollY + 60 <= scrollTo) {
          if (elem.getBoundingClientRect().top + 35 - window.scrollY < 0) {
            elem.style.width = "22.3%";
            elem.style.top = "60px";
            elem.style.position = "fixed";
            flag = true;
          } else {
            elem.style.width = "unset";
            elem.style.top = "unset";
            elem.style.position = "unset";
          }
        }

        window.onscroll = function () {
          scrollTo = elem.parentNode.clientHeight - elem.clientHeight + 77;
          elem.style.width = "22.3%";
          elem.style.maxWidth = "320px";
          if (window.scrollY + 60 > scrollTo) {
            elem.style.position = "absolute";
            if (flag === true) {
              elem.style.top = scrollTo + "px";
              flag = false;
            }
          } else if (window.scrollY + 60 <= scrollTo) {
            if (elem.getBoundingClientRect().top + 35 - window.scrollY < 0) {
              elem.style.width = "22.3%";
              elem.style.top = "60px";
              elem.style.position = "fixed";
              flag = true;
            } else {
              elem.style.width = "unset";
              elem.style.top = "unset";
              elem.style.position = "unset";
            }
          }
        };
      }
      this.setState({
        agreement: !this.props.shouldUpdateEula
      });
    }
  }, {
    key: "handleChoicesOptionChange",
    value: function handleChoicesOptionChange(values) {
      var _props = this.props,
          plans = _props.plans,
          name = _props.params.name;


      var _plan = _ramda2.default.find(_ramda2.default.propEq("planType", name), plans);
      var license = _plan.license;
      var planType = _plan.planType;

      var plansWithChosenLicense = _ramda2.default.compose(_ramda2.default.sortBy(_ramda2.default.prop("amount")), planType === "business" ? filterBPlans("Business") : filterPlans(license))(plans);

      function value(values) {
        if (values.accessResolution === 4096) {
          return {
            accessResolution: 4096,
            billing: "monthly",
            type: values.billing === "annual" ? "personal-0-app" : "personal-0-app"
          };
        } else if (values.accessResolution === 4097) {
          return {
            accessResolution: 4097,
            billing: values.billing,
            type: values.billing === "annual" ? "personal-4K-annual" : "personal-4K"
          };
        } else {
          return values;
        }
      }
      var chosenPlan = _ramda2.default.find(_ramda2.default.whereEq(_ramda2.default.omit(["seats", "projectName", "projectDetails"], license === "freelancer" ? value(values) : values)), plansWithChosenLicense);
      this.props.setChosenPlan(chosenPlan);
      this.setState({
        selectedPlan: chosenPlan,
        submittedForm: false
        // seats: values.seats || this.state.seats,
        // ...(this.state.projectName || values.projectName) && {projectName: values.projectName},
        // ...(this.state.projectDetails || values.projectDetails) && {projectDetails: values.projectDetails},
      });
    }
  }, {
    key: "handleFormSubmit",
    value: function handleFormSubmit(type) {
      var _state = this.state,
          selectedPlan = _state.selectedPlan,
          seats = _state.seats,
          projectName = _state.projectName,
          projectDetails = _state.projectDetails;

      this.setState({
        submittedForm: true
      });

      // if (selectedPlan.multiSeat) {
      //   if (!projectName || R.isEmpty(projectName.trim())) {
      //     return;
      //   }
      //   this.props.setProjectDetails({projectName, projectDetails, seats});
      // }
      this.context.router.push({ pathname: "/subscribe/" + type });
    }
  }, {
    key: "onClickHandler",
    value: function onClickHandler() {
      this.setState({
        agreement: !this.state.agreement
      });
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this2 = this;

      var _props2 = this.props,
          plans = _props2.plans,
          name = _props2.params.name,
          shouldUpdateEula = _props2.shouldUpdateEula;

      var license = _ramda2.default.find(_ramda2.default.propEq("planType", name), plans).license;

      function getOptions() {
        // if (license === 'indie') {
        //   return collapseBusinessPlans('Business', plans)
        // }
        // else if (license === 'educational') {
        //   return collapseEducationalPlans(license, plans)
        // }
        // else {
        return collapsePlans(license, plans);
        // }
      }

      var _getOptions = getOptions(),
          fields = _getOptions.fields,
          options = _getOptions.options;

      fields = ["billing"];
      options.billing = [{ name: "Monthly", value: "monthly" }];

      var _options = _ramda2.default.sortWith(_ramda2.default.descend(_ramda2.default.prop("value")));
      var _state2 = this.state,
          _state2$selectedPlan = _state2.selectedPlan,
          type = _state2$selectedPlan.type,
          multiSeat = _state2$selectedPlan.multiSeat,
          minSeats = _state2$selectedPlan.minSeats,
          maxSeats = _state2$selectedPlan.maxSeats,
          amount = _state2$selectedPlan.amount,
          initialPlan = _state2.initialPlan;


      var plansWithChosenLicense = _ramda2.default.compose(_ramda2.default.sortBy(_ramda2.default.prop("amount")), filterPlans(license))(plans);

      var monthlyAmount = {};
      var monthlyPoints = {};
      var annualAmount = {};
      var annualPoints = {};
      var annualDiscount = {};
      plansWithChosenLicense.forEach(function (plan) {
        if (plan.billing === "monthly") {
          if (monthlyPoints[plan.accessResolution]) {
            monthlyPoints[plan.accessResolution + 1] = monthlyPoints[plan.accessResolution + 1] ? monthlyPoints[plan.accessResolution + 1].push(plan.points) : [plan.points];
          } else {
            monthlyPoints[plan.accessResolution] = monthlyPoints[plan.accessResolution] ? monthlyPoints[plan.accessResolution].push(plan.points) : [plan.points];
          }
          if (monthlyAmount[plan.accessResolution]) monthlyAmount[plan.accessResolution + 1] = monthlyAmount[plan.accessResolution + 1] ? monthlyAmount[plan.accessResolution + 1].push(plan.amount) : [plan.amount];else monthlyAmount[plan.accessResolution] = monthlyAmount[plan.accessResolution] ? monthlyAmount[plan.accessResolution].push(plan.amount) : [plan.amount];
        } else if (plan.billing === "annual") {
          if (annualAmount[plan.accessResolution]) annualAmount[plan.accessResolution + 1] = annualAmount[plan.accessResolution + 1] ? annualAmount[plan.accessResolution + 1].push(plan.amount) : [plan.amount];else annualAmount[plan.accessResolution] = annualAmount[plan.accessResolution] ? annualAmount[plan.accessResolution].push(plan.amount) : [plan.amount];

          if (annualPoints[plan.accessResolution]) annualPoints[plan.accessResolution + 1] = annualPoints[plan.accessResolution + 1] ? annualPoints[plan.accessResolution + 1].push(plan.points) : [plan.points];else annualPoints[plan.accessResolution] = annualPoints[plan.accessResolution] ? annualPoints[plan.accessResolution].push(plan.points) : [plan.points];
          if (plan.discount) {
            if (annualDiscount[plan.accessResolution]) annualDiscount[plan.accessResolution + 1] = annualDiscount[plan.accessResolution + 1] ? annualDiscount[plan.accessResolution + 1].push(plan.discount) : [plan.discount];else annualDiscount[plan.accessResolution] = annualDiscount[plan.accessResolution] ? annualDiscount[plan.accessResolution].push(plan.discount) : [plan.discount];
          }
        }
      });

      if (multiSeat) {
        fields.push("seats");
        fields.push("projectName");
        fields.push("projectDetails");
        options.seats = _ramda2.default.range(minSeats, _ramda2.default.inc(maxSeats)).map(function (val) {
          return {
            name: val,
            value: val
          };
        });
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_components.SubscriptionChoices, {
          fields: fields,
          options: options,
          initialValues: (0, _extends3.default)({}, this.state.selectedPlan),
          agreement: {
            checked: this.state.agreement,
            onChange: this.onClickHandler
          },
          type: type,
          licence: license,
          seatPrice: amount,
          monthlyPoints: monthlyPoints,
          monthlyAmount: monthlyAmount,
          annualAmount: annualAmount,
          annualPoints: annualPoints,
          annualDiscount: annualDiscount,
          submittedForm: this.state.submittedForm,
          selectedPlan: this.state.selectedPlan,
          onChange: this.handleChoicesOptionChange,
          shouldUpdateEula: shouldUpdateEula
        }),
        _react2.default.createElement(_Hr2.default, null),
        _react2.default.createElement(_Button2.default, {
          className: checkoutButton,
          mode: "secondary",
          onClick: function onClick() {
            return _this2.handleFormSubmit(type);
          },
          label: "Proceed to checkout"
        })
      );
    }
  }, {
    key: "renderPriceBox",
    value: function renderPriceBox() {
      var _state3 = this.state,
          selectedPlan = _state3.selectedPlan,
          seats = _state3.seats,
          initialPlan = _state3.initialPlan;


      var subtext = _ramda2.default.cond([[_ramda2.default.equals("freelancer"), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.equals("monthly"), _ramda2.default.always("per month")], [_ramda2.default.equals("annual"), _ramda2.default.always("per month, paid yearly")]]), _ramda2.default.nthArg(1))], [_ramda2.default.equals("indie"), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.equals("monthly"), _ramda2.default.always("per month")], [_ramda2.default.equals("annual"), _ramda2.default.always("per month, paid yearly")]]), _ramda2.default.nthArg(1))], [_ramda2.default.equals("pro"), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.equals("monthly"), _ramda2.default.always("per month")], [_ramda2.default.equals("annual"), _ramda2.default.always("per month, paid yearly")]]), _ramda2.default.nthArg(1))], [_ramda2.default.equals("archviz"), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.equals("monthly"), _ramda2.default.always("per month, paid yearly")], [_ramda2.default.equals("annual"), _ramda2.default.always("per month, paid yearly")]]), _ramda2.default.nthArg(1))], [_ramda2.default.equals("educational"), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.equals("monthly"), _ramda2.default.always("per month, paid yearly")], [_ramda2.default.equals("annual"), _ramda2.default.always("per month, paid yearly")], [_ramda2.default.equals("quarterly"), _ramda2.default.always("per month, paid quarterly")], [_ramda2.default.equals("biannual"), _ramda2.default.always("per month, paid bi-annually")]]), _ramda2.default.nthArg(1))]]);

      var originalPrice = undefined;
      var price = selectedPlan.amount;
      if (selectedPlan.billing === "annual") {
        if (initialPlan) {
          originalPrice = initialPlan.amount * 12;
        } else {
          originalPrice = Math.floor(selectedPlan.amount / 0.75);
        }
        if (seats) {
          originalPrice *= seats;
        }
      }

      var _props3 = this.props,
          plans = _props3.plans,
          name = _props3.params.name;


      var license = _ramda2.default.find(_ramda2.default.propEq("planType", name), plans).license;

      var orignalPrice = 0;

      if (selectedPlan.billing === "annual" && selectedPlan.planType !== "education") {
        originalPrice = price / 12;
      } else if (selectedPlan.planType !== "education" && selectedPlan.billing !== "annual") {
        originalPrice = price;
      } else {
        originalPrice = price / selectedPlan.billingCycle;
      }

      return _react2.default.createElement(_ChoicePriceBox2.default, {
        price: price + parseInt(selectedPlan.discount ? selectedPlan.discount : 0),
        discount: selectedPlan.discount,
        originalPrice: originalPrice,
        totalPrice: price,
        footer: this.renderSideMenuFooter(),
        priceSubtext: subtext(license, selectedPlan.billing)
        // icons={[
        //   { url: '/icons/megascans_icon_2048_preview.png', alt: 'Quixel Megascans' },
        //   { url: '/icons/mixer_icon_2048_preview.png', alt: 'Quixel Mixer' },
        //   { url: 'https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/bridge_icon_2048_preview.png', alt: 'Megascans Bridge' },
        // ]}
      });
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!nextProps.isEolConfigLoading && nextProps.hasMonetizationStopped) {
        this.context.router.push({ pathname: "/" });
      }

      if (this.props.chosenPlan !== nextProps.chosenPlan) {
        return true;
      }

      if (nextState.selectedPlan !== this.state.selectedPlan || nextState.agreement !== this.state.agreement) {
        return true;
      }

      return false;
    }
  }, {
    key: "renderSideMenuFooter",
    value: function renderSideMenuFooter() {
      var plan = this.state.selectedPlan;

      var points = plan.points;
      var resolution = plan.accessResolutionName;
      var paidSubText = "year";
      var monthlyDropsCount = plan.monthlyDropsCount;

      if (plan.billing === "annual") {
        paidSubText = "year";
      } else if (plan.billing === "monthly") {
        paidSubText = "month";
      } else if (plan.billing === "quarterly") {
        paidSubText = "quarter";
      } else if (plan.billing === "biannual") {
        paidSubText = "bi-annual";
      }

      var header = "\n            <span style=\"font-size: 15px;line-height: 2;letter-spacing: 0.8px;text-transform: uppercase;color:" + _css.pallets.gray_text + "\">Your subscription includes:</span>\n            <div style=\"display: flex;justify-content: flex-start;align-items: center;margin-top: 2rem\">\n            <img style=\"width: 48px;height: 48px;\" src=\"https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png\" alt=\"Megascans\">\n            <img style=\"width: 48px;height: 48px;margin-left: 1.5625rem;\" src=\"https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png\" alt=\"Bridge\">\n            <img style=\"width: 48px;height: 48px;margin-left: 1.5625rem;\" src=\"https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/mixer_icon_2048_preview.png\" alt=\"Mixer\">\n            </div>\n    ";

      var li = points ? "<li>Quixel Megascans with " + points + " points/" + paidSubText + "</li>" : "";
      var freeDrop = "<li>A monthly, free drop of " + monthlyDropsCount + " bonus assets, selected just for you</li>";

      if (plan.license === "archviz") {
        li = points ? "<li>Quixel Megascans for ArchViz with " + points + " points/" + paidSubText + "</li>" : "";
      }
      var message = "\n        " + header + "\n        <ul style=\"list-style-type: disc; padding-left:20px;padding-top:30px; \">\n          " + li + "\n          <li>" + resolution + " resolution</li>\n          <li>Quixel Bridge</li>\n          <li>Quixel Mixer</li>\n          <li>Access to free assets on the Megascans library</li>\n            " + freeDrop + "\n        </ul>";
      if (plan.license === "educational") {
        message = "\n        " + header + "\n        <ul style=\"list-style-type: disc; padding-left:20px;padding-top:30px; \">\n          <li>Quixel Megascans asset pack</li>\n          <li>Quixel Bridge</li>\n          <li>Quixel Mixer</li>\n        </ul>\n        ";
      }
      if (plan.type === "personal-0-app" && plan.billing === "monthly") {
        message = "\n        " + header + "\n        <ul style=\"list-style-type: disc; padding-left:20px;padding-top:30px; \">\n          <li>Quixel Bridge</li>\n          <li>Quixel Mixer</li>\n          <li>Access to free assets on the Megascans library</li>\n          " + freeDrop + "\n        </ul>\n        ";
      }
      if (plan.type === "personal-4K" || plan.type === "personal-4K-annual") {
        message = "\n        " + header + "\n        <ul style=\"list-style-type: disc; padding-left:20px;padding-top:30px; \">\n          " + li + "\n          <li>" + resolution + " resolution</li>\n          <li>Quixel Bridge</li>\n          <li>Quixel Mixer</li>\n          <li>Access to free assets on the Megascans library</li>\n          " + freeDrop + "\n        </ul>";
      }
      var messageContainer = "<div style=\"line-height: 24px; font-size: 0.9375rem; letter-spacing: -0.4px; font-weight: 400;\">" + message + "</div>";

      return messageContainer;
    }
  }, {
    key: "renderStickyBar",
    value: function renderStickyBar() {
      var _this3 = this;

      var _state4 = this.state,
          selectedPlan = _state4.selectedPlan,
          seats = _state4.seats,
          initialPlan = _state4.initialPlan;


      var subtext = _ramda2.default.cond([[_ramda2.default.equals("monthly"), _ramda2.default.always("per month")], [_ramda2.default.equals("annual"), _ramda2.default.always("per year")], [_ramda2.default.equals("quarterly"), _ramda2.default.always("per year")], [_ramda2.default.equals("biannual"), _ramda2.default.always("per year")]]);

      var price = seats ? selectedPlan.amount * seats : selectedPlan.amount;
      var originalPrice = undefined;

      if (selectedPlan.billing === "annual") {
        if (initialPlan) {
          originalPrice = initialPlan.amount * 12;
        } else {
          originalPrice = Math.floor(selectedPlan.amount / 0.75);
        }
        if (seats) {
          originalPrice *= seats;
        }
      }
      return _react2.default.createElement(_ChoicePriceStickyHeader2.default, {
        price: price,
        originalPrice: selectedPlan.billing === "annual" ? seats ? parseInt(selectedPlan.amount * seats / 0.75) : parseInt(selectedPlan.amount / 0.75) : undefined,
        priceSubtext: subtext(selectedPlan.billing),
        proceedTo: this.state.agreement ? "/subscribe/" + selectedPlan.type : "",
        onClick: function onClick() {
          return _this3.handleFormSubmit(selectedPlan.type);
        },
        disabled: !this.state.agreement
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          plans = _props4.plans,
          educationalPlan = _props4.educationalPlan,
          name = _props4.params.name,
          chosenPlan = _props4.chosenPlan;
      //plansDecorated=license==='educational'?this.props.plans:plansDecorated;

      var plan = _ramda2.default.find(_ramda2.default.propEq("planType", name), plans);

      var title = void 0,
          subTitle = void 0;

      if (plan.planType === "business") {
        title = "Quixel for Business";
        subTitle = "For businesses with less than $2M yearly revenue or funds raised.";
      } else if (plan.planType === "education") {
        title = "Quixel Educational XL Program";
        subTitle = "Thousands of Megascans assets, and full-featured access to Quixel Bridge and Quixel Mixer.";
      } else if (plan.planType === "archviz") {
        title = "Quixel for ArchViz";
        subTitle = "For businesses specializing primarily in architectural visualization.";
      } else if (chosenPlan && chosenPlan.type.indexOf("pro") > -1) {
        title = "Pro";
        subTitle = "For teams with under $20M in funding or yearly revenue.";
      } else if (chosenPlan && chosenPlan.type.indexOf("personal") > -1) {
        title = "Personal";
        subTitle = "For individuals with under $100K in funding or yearly revenue.";
      } else {
        title = "Indie";
        subTitle = "For teams with under $2M in funding or yearly revenue.";
      }

      if (this.props.isEolConfigLoading) {
        return _react2.default.createElement(
          "div",
          { className: spinnerStyles },
          _react2.default.createElement(_Preloader2.default, null)
        );
      }

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "| " + (name.charAt(0).toUpperCase() + name.slice(1)) + " Subscription Plan",
          documentDescription: "" + (name.indexOf("personal") > -1 ? "This plan is for individuals with under 100k funding or yearly revenue. Receive 90 points every month to use on 3D assets, surfaces, decals, and more." : name.indexOf("indie") > -1 ? "This plan is for teams with under $2M in funding or yearly revenue. That’s 45 surfaces, 22 3D models, or 90 scans of any other type every month." : "") },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_SiteHeaderGap2.default, null),
          _react2.default.createElement(_CheckoutLayout2.default
          // showBanner
          , { headerIconSrc: "/quixel_logo.png",
            title: title,
            subTitle: subTitle,
            form: this.renderOptions(),
            sidebarOnDesktop: this.renderPriceBox(),
            stickyBarOnMobile: this.renderStickyBar()
          })
        )
      );
    }
  }]);
  return ChooseSubscription;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = (0, _reactRouter.withRouter)(ChooseSubscription);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ChooseSubscription/ChooseSubscription.jsx
// module id = 2904
// module chunks = 0